import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
import { appointments as defaultAppointments, tasks as defaultTasks } from '../../../../src/components/views/common/Agenda/data.js';

export const schedulerTraySlice = createSlice({
  name: 'schedulerTray',
  initialState:{
    tasks:[]
  },
  reducers: {
    setSchedulerTrayReducer: (state, action) => {
      state.tasks = action.payload;
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { setSchedulerTrayReducer } = schedulerTraySlice.actions
export default schedulerTraySlice.reducer 
